import { newE2EPage } from "@stencil/core/testing";
import { testValidHtmlElement } from "../../../../test-utils/html-validate";

describe("table-column-checkbox", () => {
    it("should match to snapshot with data", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table>
            <uic-table-column-checkbox label="test" field="x"></uic-table-column-checkbox>
        </uic-table>`);
        const el = await page.find("uic-table");
        el.setProperty("data", [{ x: true }, { x: false }]);
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table>
            <uic-table-column-checkbox label="test" field="x"></uic-table-column-checkbox>
        </uic-table>`);
        const el = await page.find("uic-table");
        el.setProperty("data", [{ x: true }, { x: false }]);
        await page.waitForChanges();
        await testValidHtmlElement(el);
    });
});
